/* ============================================================
   W. Oweson — theme.js
   Nav + footer toggles run on every page. The product page also
   re-orders its two columns into one on mobile (image-1 → text →
   image-2 …). The page/info base handles mobile purely in CSS.
   Every block guards for the elements it needs.
   ============================================================ */
(function () {
  'use strict';

  /* ══ NAV ══ */
  var navPanel  = document.getElementById('nav-panel');
  var navToggle = document.getElementById('nav-toggle');
  var NAV_OPEN_W = 80;

  function measureNavOpenHeight() {
    navPanel.style.transition = 'none';
    navPanel.style.width  = NAV_OPEN_W + 'px';
    navPanel.style.height = 'auto';
    var h = navPanel.scrollHeight;
    navPanel.offsetHeight;
    navPanel.style.width  = 'var(--bbtn-size)';
    navPanel.style.height = 'var(--bbtn-size)';
    navPanel.offsetHeight;
    navPanel.style.transition = '';
    return h;
  }

  if (navPanel && navToggle) {
    navToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = navPanel.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        var h = measureNavOpenHeight();
        navPanel.style.width  = NAV_OPEN_W + 'px';
        navPanel.style.height = h + 'px';
      } else {
        navPanel.style.width  = 'var(--bbtn-size)';
        navPanel.style.height = 'var(--bbtn-size)';
      }
    });
    navPanel.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  /* ══ FOOTER ══ */
  var footer       = document.getElementById('footer');
  var footerToggle = document.getElementById('footer-toggle');
  var footerLinks  = document.getElementById('footer-links');
  var collapsedW = 0;
  var expandedW  = 0;

  function initFooterWidths() {
    if (!footer || !footerLinks) return;
    footerLinks.style.display = 'none';
    footer.style.width = 'max-content';
    collapsedW = footer.scrollWidth;
    footer.style.width = '';

    footerLinks.style.display = '';
    footer.style.width = 'max-content';
    expandedW = footer.scrollWidth;
    footer.style.width = '';

    footer.style.width = collapsedW + 'px';
  }

  if (footer && footerToggle) {
    footerToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = footer.classList.toggle('open');
      footerToggle.setAttribute('aria-expanded', isOpen);
      footer.style.width = isOpen ? expandedW + 'px' : collapsedW + 'px';
    });
    footer.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  /* ══ Close on outside click ══ */
  document.addEventListener('click', function () {
    if (navPanel && navPanel.classList.contains('open')) {
      navPanel.classList.remove('open');
      navPanel.style.width  = 'var(--bbtn-size)';
      navPanel.style.height = 'var(--bbtn-size)';
      navToggle.setAttribute('aria-expanded', 'false');
    }
    if (footer && footer.classList.contains('open')) {
      footer.classList.remove('open');
      footer.style.width = collapsedW + 'px';
      footerToggle.setAttribute('aria-expanded', 'false');
    }
  });

  /* ══ Product mobile reorder: image-1 → text → image-2, image-3 … ══ */
  var pageLayout    = document.getElementById('page-layout');
  var mobileCol     = document.getElementById('mobile-col');
  var productText   = document.getElementById('product-text');
  var productImages = document.getElementById('product-images');
  var BREAKPOINT    = 750;
  var mobileDone    = false;

  var hasProductReorder = pageLayout && mobileCol && productText && productImages;

  function toMobile() {
    if (mobileDone) return;
    mobileDone = true;

    pageLayout.style.display      = 'none';
    mobileCol.style.display       = 'flex';
    mobileCol.style.flexDirection = 'column';
    mobileCol.innerHTML           = '';

    var imgs = Array.prototype.slice.call(productImages.querySelectorAll('.product-image'));
    imgs.forEach(function (img, i) {
      var imgClone = img.cloneNode(true);
      imgClone.style.width = '100%';
      imgClone.style.flexShrink = '0';
      mobileCol.appendChild(imgClone);
      if (i === 0) {
        var t = productText.cloneNode(true);
        t.style.position = 'static';
        t.style.height = 'auto';
        t.style.width = '100%';
        t.style.display = 'flex';
        t.style.flexDirection = 'column';
        mobileCol.appendChild(t);
      }
    });
  }

  function toDesktop() {
    if (!mobileDone) return;
    mobileDone = false;
    mobileCol.style.display  = 'none';
    mobileCol.innerHTML      = '';
    pageLayout.style.display = '';
  }

  function checkBreakpoint() {
    if (!hasProductReorder) return;
    if (window.innerWidth <= BREAKPOINT) { toMobile(); } else { toDesktop(); }
  }

  /* ══ Init ══ */
  window.addEventListener('DOMContentLoaded', function () {
    checkBreakpoint();
    initFooterWidths();
  });
  window.addEventListener('resize', checkBreakpoint);
})();
